import {
  MClassLavTargetValuesEnum,
  MClassUoTargetValuesEnum,
  MClassUlTargetValuesEnum,
  MClassFTiTargetValuesEnum,
  MClassReiTargetValuesEnum,
  CClassEavTargetValuesEnum,
  CClassUoTargetValuesEnum,
  CClassFTiTargetValuesEnum,
  PClassEavTargetValuesEnum,
  PClassEminTargetValuesEnum,
  PClassEvminTargetValuesEnum,
  PClassEscminTargetValuesEnum,
  PClassFTiTargetValuesEnum,
} from "../../types";

export const M_TABLE = [
  ["M1", MClassLavTargetValuesEnum.M1, MClassUoTargetValuesEnum.M1, MClassUlTargetValuesEnum.M1, MClassFTiTargetValuesEnum.M1, MClassReiTargetValuesEnum.M1],
  ["M2", MClassLavTargetValuesEnum.M2, MClassUoTargetValuesEnum.M2, MClassUlTargetValuesEnum.M2, MClassFTiTargetValuesEnum.M2, MClassReiTargetValuesEnum.M2],
  ["M3", MClassLavTargetValuesEnum.M3, MClassUoTargetValuesEnum.M3, MClassUlTargetValuesEnum.M3, MClassFTiTargetValuesEnum.M3, MClassReiTargetValuesEnum.M3],
  ["M4", MClassLavTargetValuesEnum.M4, MClassUoTargetValuesEnum.M4, MClassUlTargetValuesEnum.M4, MClassFTiTargetValuesEnum.M4, MClassReiTargetValuesEnum.M4],
  ["M5", MClassLavTargetValuesEnum.M5, MClassUoTargetValuesEnum.M5, MClassUlTargetValuesEnum.M5, MClassFTiTargetValuesEnum.M5, MClassReiTargetValuesEnum.M5],
  ["M6", MClassLavTargetValuesEnum.M6, MClassUoTargetValuesEnum.M6, MClassUlTargetValuesEnum.M6, MClassFTiTargetValuesEnum.M6, MClassReiTargetValuesEnum.M6],
];

export const C_TABLE = [
  ["C0", CClassEavTargetValuesEnum.C0, CClassUoTargetValuesEnum.C0, CClassFTiTargetValuesEnum.C0],
  ["C1", CClassEavTargetValuesEnum.C1, CClassUoTargetValuesEnum.C1, CClassFTiTargetValuesEnum.C1],
  ["C2", CClassEavTargetValuesEnum.C2, CClassUoTargetValuesEnum.C2, CClassFTiTargetValuesEnum.C2],
  ["C3", CClassEavTargetValuesEnum.C3, CClassUoTargetValuesEnum.C3, CClassFTiTargetValuesEnum.C3],
  ["C4", CClassEavTargetValuesEnum.C4, CClassUoTargetValuesEnum.C4, CClassFTiTargetValuesEnum.C4],
  ["C5", CClassEavTargetValuesEnum.C5, CClassUoTargetValuesEnum.C5, CClassFTiTargetValuesEnum.C5],
];

export const P_TABLE = [
  ["P1", PClassEavTargetValuesEnum.P1, PClassEminTargetValuesEnum.P1, PClassEvminTargetValuesEnum.P1, PClassEscminTargetValuesEnum.P1, PClassFTiTargetValuesEnum.P1],
  ["P2", PClassEavTargetValuesEnum.P2, PClassEminTargetValuesEnum.P2, PClassEvminTargetValuesEnum.P2, PClassEscminTargetValuesEnum.P2, PClassFTiTargetValuesEnum.P2],
  ["P3", PClassEavTargetValuesEnum.P3, PClassEminTargetValuesEnum.P3, PClassEvminTargetValuesEnum.P3, PClassEscminTargetValuesEnum.P3, PClassFTiTargetValuesEnum.P3],
  ["P4", PClassEavTargetValuesEnum.P4, PClassEminTargetValuesEnum.P4, PClassEvminTargetValuesEnum.P4, PClassEscminTargetValuesEnum.P4, PClassFTiTargetValuesEnum.P4],
  ["P5", PClassEavTargetValuesEnum.P5, PClassEminTargetValuesEnum.P5, PClassEvminTargetValuesEnum.P5, PClassEscminTargetValuesEnum.P5, PClassFTiTargetValuesEnum.P5],
  ["P6", PClassEavTargetValuesEnum.P6, PClassEminTargetValuesEnum.P6, PClassEvminTargetValuesEnum.P6, PClassEscminTargetValuesEnum.P6, PClassFTiTargetValuesEnum.P6],
];
